import { configureStore } from '@reduxjs/toolkit';
import roleReducer from '../Reducers/role';
import navigationReducer from '../Reducers/navigation';
import successReducer from '../Reducers/snackSuccess';
import errorsReducer from '../Reducers/snackErrors';
import permissionsReducer from '../Reducers/permissions';


const saveToLocalStorage = (store) => (next) => (action) => {
  const result = next(action);

  if (action.type.startsWith('success/')) {
    const { success } = store.getState();
    try {
      localStorage.setItem('success', JSON.stringify(success));
    } catch (e) {
      console.error("Failed to save success to localStorage:", e);
    }
  }

  if (action.type.startsWith('errors/')) {
    const { errors } = store.getState();
    try {
      localStorage.setItem('errors', JSON.stringify(errors));
    } catch (e) {
      console.error("Failed to save errors to localStorage:", e);
    }
  }
  // Save role state to local storage
  if (action.type.startsWith('role/')) {
    const { role } = store.getState();
    try {
      localStorage.setItem('role', JSON.stringify(role));
    } catch (e) {
      console.error("Failed to save role to localStorage:", e);
    }
  }
  if (action.type.startsWith('navigation/')) {
    const { navigation } = store.getState();
    try {
      localStorage.setItem('navigation', JSON.stringify(navigation));
    } catch (e) {
      console.error("Failed to save navigation to localStorage:", e);
    }
  }
  if (action.type.startsWith('permissions/')) {
    const { permissions } = store.getState();
    try {
      localStorage.setItem('permissions', JSON.stringify(permissions));
    } catch (e) {
      console.error("Failed to save role to localStorage:", e);
    }
  }

  return result;
};
// Load initial state from localStorage
const preloadedState = {
  role: JSON.parse(localStorage.getItem('role')) || {},
  navigation: JSON.parse(localStorage.getItem('navigation')) || {},
  success: JSON.parse(localStorage.getItem('success')) || {},
  errors: JSON.parse(localStorage.getItem('errors')) || {},
  permissions: JSON.parse(localStorage.getItem('permissions')) || {}
};

const store = configureStore({
  reducer: {
    role: roleReducer,
    navigation: navigationReducer,
    success: successReducer,
    errors: errorsReducer,
    permissions: permissionsReducer,
  },
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(saveToLocalStorage),
});

export default store;
